import React from "react";
import { TextField } from "@mui/material";
import { useField, useFormikContext } from "formik";
import DatePicker from "react-datepicker";
import es from 'date-fns/locale/es';
import { registerLocale } from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.module.css';
import moment from "moment";

registerLocale('es', es)
export const AppDatePicker = (props) => {
  const { setFieldValue } = useFormikContext();
  const [field] = useField(props);
  const getFormat = () => {
    switch (props.format) {
      case 'YYYY-MM-DD':
        return 'yyyy-MM-dd';
      case 'YYYY-MM':
        return 'yyyy-MM';
      default:
        return 'yyyy-MM-dd'
    }
  }
  return !props?.custom ? (
    <TextField
      type='date'
      {...field}
      {...props}
      onChange={val => {
        setFieldValue(field.name, moment(val?.target?.value).format(props.format));
      }}
    />) : (<DatePicker
      className="custom-theme"
      {...field}
      {...props}
      selected={(field.value && new Date(field.value)) || null}
      onChange={val => {
        setFieldValue(field.name, val ? (moment(val).format(props.format)) : '');
      }}
      dateFormat={getFormat()}
    />)
};